"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = exports.Body = exports.Title = exports.Header = exports.CollapsibleItemHeader = exports.CollapsibleItemBody = exports.CollapsibleItem = exports.CollapsibleSection = exports.Container = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
Object.defineProperty(exports, "Container", { enumerable: true, get: function () { return react_bootstrap_1.Offcanvas; } });
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("../../../assets/styles/config");
const CollapsibleSections_1 = require("./CollapsibleSections");
Object.defineProperty(exports, "CollapsibleSection", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleSection; } });
Object.defineProperty(exports, "CollapsibleItem", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItem; } });
Object.defineProperty(exports, "CollapsibleItemBody", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItemBody; } });
Object.defineProperty(exports, "CollapsibleItemHeader", { enumerable: true, get: function () { return CollapsibleSections_1.CollapsibleItemHeader; } });
exports.Header = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Header) `
  display: flex;
  align-items: center;
  padding: 1.3rem 1rem;
`;
exports.Title = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Title) `
  font-weight: 600;
  font-size: ${config_1.fontSizes.base};
  font-family: ${config_1.fontFamilies.primary};
  margin-bottom: 0;
`;
exports.Body = (0, styled_components_1.default)(react_bootstrap_1.Offcanvas.Body) `
  padding: 0;
`;
const StyledCloseButton = styled_components_1.default.button `
  background: none;
  border: none;
  i {
    font-weight: 600;
    font-size: 1.2rem;
  }
`;
const CloseButton = ({ onClick, icon = 'arrow-right' }) => (react_1.default.createElement(StyledCloseButton, { onClick: onClick },
    react_1.default.createElement("i", { className: `fe fe-${icon}` })));
exports.CloseButton = CloseButton;
